import { render, staticRenderFns } from "./pricing-loop.vue?vue&type=template&id=4509fb04&"
import script from "./pricing-loop.vue?vue&type=script&lang=js&"
export * from "./pricing-loop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports